import {
  Action,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import reducer  from './links/linkSlice';

export const store = configureStore({
  reducer: {
    link: reducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
   ReturnType,
   RootState,
   unknown,
   Action<string>
 >;